module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectMic":"Select microphone"}}')
  delete Component.options._Ctor
}
